/**
 * Implements slot info helper
 */
export const getSlotListUILogic = (slotList = []) => {
  const mapSlotList = [];
  const slotLen = slotList.length || 0;

  for (let i = 0; i < slotLen; i++) {
    const slot = slotList[i];
    if (slot.cameraMAC) {
      // eslint-disable-next-line no-unused-vars
      const { ui = {}, ...rest } = slot;
      mapSlotList.push({ ...rest, slotNo: `${i + 1}` });
    }
  }

  return { mapSlotList };
};

export const getDefaultList = () => {
  return [];
};

export const findNvrRecRtspUrl = (data) => {
  const { cameraRtspChannels = [] } = data;
  const nvr = cameraRtspChannels.find(channel => channel.profileName === data.cameraNvrRecRtspPreferred);
  return nvr ? nvr.rtspUrl : '';
};

export const findAanalyzeRtspUrl = (data) => {
  const { cameraRtspChannels = [] } = data;
  const analyze = cameraRtspChannels.find(channel => channel.profileName === data.cameraAnalyzeRtspPreferred);
  return analyze ? analyze.rtspUrl : '';
};

// eslint-disable-next-line no-unused-vars
export const confDetailsJsonToObj = (config_details='') => {
  return JSON.parse(config_details);
};

// export const confDetailsJsonToObj = (config_details='') => {
//   let obj = JSON.parse(config_details);
//   obj.basic_installation = {
//     install_progress_step: 1
//   };
//   obj.slot_configuration = {
//     nb_activ_slot: 8,
//     nb_max_slot: 12,
//     slots: [
//       {
//         cameraBrand: 'Axis',
//         cameraIpAddr: '10.27.15.1',
//         cameraTestedStatus: 2,
//         cameraMAC: '12:45:78:34:56:1',
//         port: 80,
//         cameraUserName: 'admin',
//         cameraPassword: 'admin',
//         cameraAnalyzeRtspPreferred: 'S',
//         cameraNvrRecRtspPreferred: 'D',        
//         cameraRtspChannels: [{
//           profileName: 'S',
//           codec: 'H264',
//           fps: 30,
//           height: 720,
//           width: 1280,
//           rtspUrl: 'rtsp://10.27.15.130/onvig-media/S'
//         }, {
//           profileName: 'D',
//           codec: 'H264',
//           fps: 30,
//           height: 720,
//           width: 1280,
//           rtspUrl: 'rtsp://10.27.15.130/onvig-media/D'
//         }, {
//           profileName: 'E',
//           codec: 'JPEG',
//           fps: 30,
//           height: 720,
//           width: 1280,
//           rtspUrl: 'rtsp://10.27.15.130/onvig-media'          
//         }, {
//           profileName: 'U',
//           codec: 'H264',
//           fps: 30,
//           height: 720,
//           width: 1280
//         }],
//         cameraModel: 'IPC-HD4563-ZS345',
//         cameraHWid: '1.0',
//         cameraFWVersion: '2.0',
//         cameraSN: '4463539'
//       },
//       {
//         cameraBrand: 'Dahua',
//         cameraIpAddr: '10.27.15.2',
//         cameraTestedStatus: 2,
//         cameraMAC: '12:45:78:43:65:1',
//         port: 80,
//         cameraUserName: 'admin',
//         cameraPassword: 'admin',
//         cameraRtspChannels: [{
//           profileName: 'D'
//         }, {
//           profileName: 'S'
//         }],
//         cameraModel: 'IPC-HD4563-ZS345',
//         cameraHWid: '1.0',
//         cameraFWVersion: '2.0',
//         cameraSN: '4463539'
//       }      
//     ]
//   };
//   return obj;
// };